
































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Getter, Action } from 'vuex-class'
import { TweenMax, Power1 } from 'gsap'
import { Watch } from 'vue-property-decorator'
import { themeColors } from '@/plugins/vuetify/theme'
import { sleep } from '@/core/utilities/time'
import { SHOW_INTRO_KEY } from '@//constants'
import { gradientBackgroundFromColor } from '@/utilities/colors'


@Component({
  components: { }
})
export default class IntroPage extends Vue {

  page = 1  //* gets set by pagination and buttons
  index = 0 //* follows after animation
  
  @Getter('os', { namespace: 'system' }) OS!: string
  @Getter('windowHeight', { namespace: 'system' }) windowHeight!: boolean
  @Getter('loggedIn', { namespace: 'auth' }) loggedIn!: boolean

  get currentPage() { return this.pages[this.index] }

  get gradientBackground() { return gradientBackgroundFromColor(themeColors.menuBackground) }

  get pages() {
    const pages = [
      {
        title: 'Welkom in de online training werkgeluk!',
        picture: 'usp-small',
        pictureDesktop: 'usp-large',
        params: 'c_scale,h_800,q_auto:eco',
        paramsDesktop: 'c_scale,h_2000'
      },
      {
        title: 'Doorloop microlessen, laat je inspireren.',
        picture: 'microlesson-small',
        pictureDesktop: 'microlesson-large',
        params: 'c_scale,h_800,q_auto:eco',
        paramsDesktop: 'c_scale,h_2000'
      },
      {
        title: 'Geef jouw mening. Het materiaal wordt hierop aangepast.',
        picture: 'feedback-small',
        pictureDesktop: 'feedback-large',
        params: 'c_scale,h_800,q_auto:eco',
        paramsDesktop: 'c_scale,h_2000'
      },
      {
        title: 'Ontgrendel verschillende apps voor meer werkgeluk.',
        picture: 'mini-apps-small',
        pictureDesktop: 'mini-apps-large',
        params: 'c_scale,h_800,q_auto:eco',
        paramsDesktop: 'c_scale,h_2000'
      }
    ]

    if (this.OS === 'Android') {
      pages.push({
        title: 'Open de app vanaf het startscherm voor een fullscreen ervaring.',
        picture: 'android-small',
        pictureDesktop: 'android-large',
        params: 'c_scale,h_800,q_auto:eco',
        paramsDesktop: 'c_scale,h_2000'
      })
    }
    else if (this.OS === 'iOS') {
      pages.push({
        title: 'Open de app vanaf het startscherm voor een fullscreen ervaring.',
        picture: 'iphone-small',
        pictureDesktop: 'iphone-large',
        params: 'c_scale,h_800,q_auto:eco',
        paramsDesktop: 'c_scale,h_2000'
      })
    }
    
    return pages
  }


  @Watch('page')
  async onPageChanged(newPage: number, oldPage: number | null) {
    const animationDirection = oldPage && newPage < oldPage ? 1 : -1
    await this.fadeOut(animationDirection)
    const newIndex = newPage - 1
    this.index = newIndex
    await this.fadeIn(animationDirection)

    // * set intro shown if on last page
    if (this.pages.length <= this.page) {
      localStorage.setItem(SHOW_INTRO_KEY, 'false')
    }
  }


  async saveAndClose() {
    localStorage.setItem(SHOW_INTRO_KEY, 'false')
    this.$router.push('/')
  }


  async fadeOut(direction: number) {
    const duration = .25
    TweenMax.to( '#page-title', duration, { autoAlpha: 0, x: 200 * direction, ease: Power1.easeIn } )
    TweenMax.to( '#picture', duration, { autoAlpha: 0, x: 20 * direction, ease: Power1.easeIn } )
    return sleep(duration * 1000)
  }


  async fadeIn(direction: number) {
    const duration = .25
    TweenMax.to( '#page-title', 0, { autoAlpha: 0, x: 200 * -direction,  ease: Power1.easeIn, delay: duration } )
    TweenMax.to( '#page-title', duration, { autoAlpha: 1, x: 0, ease: Power1.easeOut, delay: duration } )
    TweenMax.to( '#picture', 0, { autoAlpha: 0, x: 20 * -direction,  ease: Power1.easeIn, delay: duration } )
    TweenMax.to( '#picture', duration, { autoAlpha: 1, x: 0, ease: Power1.easeOut, delay: duration } )
    return sleep(duration * 1000)
  }


  login() {
    this.$router.push('login')
  }


  signUp() {
    this.$router.push('signup')
  }


  skip() {
    if (this.loggedIn) {
      this.saveAndClose()
    }
    else {
      this.page = this.pages.length
    }
  }
}
